export default {
    SET_CONTRACT_INFO(state, response) {
        return state.contractInfo = response
    }
};